/**
 * R2 - GROQ queries for fetching landing page data
 * R4 - Single query fetches the entire singleton to minimize API calls
 * 
 * The landingPage document uses a known _id ("landingPage") set in the Studio.
 * We use *[_type == "landingPage"][0] as a safe fallback.
 */

// Fetch the full landing page singleton in one round-trip
export const LANDING_PAGE_QUERY = /* groq */ `
  *[_type == "landingPage"][0] {
    companyName,
    contactInfo {
      email,
      phone,
      phoneRaw,
      whatsappNumber,
      whatsappDefaultMessage,
      address
    },
    hero {
      badge,
      headingPrefix,
      flipWords,
      description,
      ctaPrimaryText,
      ctaSecondaryText,
      carouselItems[] {
        beforeImage { asset->, hotspot, crop },
        afterImage  { asset->, hotspot, crop },
        alt
      }
    },
    services {
      title,
      description,
      items[] { title, description, iconName }
    },
    sectors {
      title,
      description,
      items[] { title, description, iconName }
    },
    products {
      badge,
      title,
      description,
      ctaText,
      items[] {
        title,
        description,
        image { asset->, hotspot, crop },
        category,
        features,
        isFeatured
      }
    },
    cta {
      badge,
      headingLine1,
      headingLine2,
      description,
      ctaPrimaryText,
      ctaSecondaryText,
      trustIndicators[] { value, label, colorVariant }
    },
    footer {
      companyDescription,
      linkGroups[] {
        title,
        links[] { label, href }
      }
    },
    about {
      heroBadge,
      heroTitle,
      heroDescription,
      historyBadge,
      historyTitle,
      historyParagraph1,
      historyParagraph2,
      servicesBadge,
      servicesTitle,
      servicesDescription,
      servicesItems[] { title, iconName },
      commitmentBadge,
      commitmentTitle,
      commitmentParagraph1,
      commitmentParagraph2,
      ctaBadge,
      ctaHeadingLine1,
      ctaHeadingLine2,
      ctaDescription
    },
    contact {
      title,
      description,
      formTitle,
      formDescription
    }
  }
`;
